import { render } from "./FormFileHeader.vue?vue&type=template&id=42779a82&scoped=true"
import script from "./FormFileHeader.vue?vue&type=script&lang=js"
export * from "./FormFileHeader.vue?vue&type=script&lang=js"

import "./FormFileHeader.vue?vue&type=style&index=0&id=42779a82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-42779a82"

export default script